import { MutableRefObject, useCallback, useRef, useState } from "react";
import { ReactPlayerProps } from "react-player";

export interface UseVideoPlayData {
  played: number;
  playedSeconds: number;
  loaded: number;
  loadedSeconds: number;
}

export const useVideo = (
  props: ReactPlayerProps,
): [
  ReactPlayerProps,
  MutableRefObject<any>,
  () => void,
  (playedData: UseVideoPlayData) => void,
  (duration: number) => void,
  () => void,
  (value) => void,
  (value) => void,
  () => void,
  (value) => void,
] => {
  const [state, setState] = useState<ReactPlayerProps>({
    controls: false,
    light: false,
    seeking: 0,
    played: 0,
    loaded: 0,
    duration: 0,
    playbackRate: 1.0,
    volume: props.muted ? 0 : 1,
    ...props,
  });

  const [volumeMemo, setVolumeMemo] = useState<number>(props.volume || 1);

  const player = useRef(null);

  const handlePlayPause = useCallback(() => {
    setState({ ...state, playing: !state.playing });
  }, [state]);

  const handleProgress = (playedData: UseVideoPlayData) => {
    if (!state.seeking && state.playing) {
      setState({ ...state, played: playedData.played });
    }
  };

  const handleDuration = (duration: number) => {
    setState({ ...state, duration });
  };

  const handleSeekMouseDown = () => {
    setState({ ...state, seeking: 1 });
  };

  const handleSeekMouseUp = (value) => {
    setState({ ...state, seeking: 0 });
    player?.current?.seekTo(parseFloat(value));
  };

  const handleSeekChange = (value) => {
    setState({ ...state, played: parseFloat(value) });
  };

  const toggleMute = () => {
    const newVolume = state.muted ? volumeMemo : 0;
    setState({ ...state, muted: !state.muted, volume: newVolume });
  };

  const handleVolumeChange = (value) => {
    setState({ ...state, volume: parseFloat(value), muted: false });
    setVolumeMemo(parseFloat(value));
  };

  return [
    state,
    player,
    handlePlayPause,
    handleProgress,
    handleDuration,
    handleSeekMouseDown,
    handleSeekMouseUp,
    handleSeekChange,
    toggleMute,
    handleVolumeChange,
  ];
};
